import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetServicingV1InstrumentsTokenTokenQuery, useGetServicingV1InstrumentsInstrumentIdFinalizeQuery, } from 'servicing-api';
import { setInstrumentId, setFinancialStatus, setAccountNumber, } from '../actions';
import { selectors } from '../reducer';
function useFlexFinalizeData(authorizationToken) {
    const dispatch = useDispatch();
    const instrumentIdFromSelector = useSelector((state) => selectors.instrumentId(state));
    const accountNumberFromSelector = useSelector((state) => selectors.accountNumber(state));
    // Only fetch token if we don't yet have the instrument identity in Redux
    const shouldFetchToken = (!instrumentIdFromSelector || !accountNumberFromSelector) &&
        !!authorizationToken;
    const { data: tokenRes, isLoading: tokenIsLoading, isFetching: tokenIsFetching, } = useGetServicingV1InstrumentsTokenTokenQuery({ token: authorizationToken || '' }, { skip: !shouldFetchToken });
    // Use instrumentId from Redux or from the in-flight token response
    const instrumentId = instrumentIdFromSelector || (tokenRes?.id ? Number(tokenRes.id) : null);
    const { data: finalizeData, isLoading: finalizeIsLoading, isFetching: finalizeIsFetching, } = useGetServicingV1InstrumentsInstrumentIdFinalizeQuery({ instrumentId: instrumentId }, { skip: !instrumentId });
    // Store thin coordination state in Redux when the token resolves
    useEffect(() => {
        if (tokenRes && (!instrumentIdFromSelector || !accountNumberFromSelector)) {
            dispatch(setInstrumentId(Number(tokenRes.id)));
            dispatch(setFinancialStatus(tokenRes.financialStatus));
            dispatch(setAccountNumber(tokenRes.accountId));
        }
    }, [tokenRes, instrumentIdFromSelector, accountNumberFromSelector, dispatch]);
    const isLoading = (shouldFetchToken && (tokenIsLoading || tokenIsFetching)) ||
        (!!instrumentId && (finalizeIsLoading || finalizeIsFetching));
    return {
        instrumentId,
        finalizeData: finalizeData ?? null,
        tokenRes: tokenRes || null,
        isLoading,
    };
}
export default useFlexFinalizeData;
